import React from 'react';
import { Box, Chip } from '@mui/material';
import { isPathActive } from '../../router/navigation';

export default function MobileSectionTabs({ section, pathname, onNavigate }) {
  const activeRef = React.useRef(null);

  React.useEffect(() => {
    activeRef.current?.scrollIntoView({ block: 'nearest', inline: 'center' });
  }, [pathname]);

  if (!section || section.children.length < 2) {
    return null;
  }

  return (
    <Box
      sx={{
        flexShrink: 0,
        display: 'flex',
        gap: 1,
        px: 2,
        py: 1,
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      {section.children.map((child) => {
        const selected = isPathActive(pathname, child.path);

        return (
          <Chip
            key={child.path}
            ref={selected ? activeRef : undefined}
            label={child.title}
            clickable
            color={selected ? 'primary' : 'default'}
            variant={selected ? 'filled' : 'outlined'}
            onClick={() => onNavigate(child.path)}
            sx={{ flexShrink: 0, fontWeight: selected ? 600 : 500 }}
          />
        );
      })}
    </Box>
  );
}
